import { CommonModule } from "@angular/common";
import { Component, OnInit, ViewChild, inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButton } from "@angular/material/button";
import { MatError, MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { catchError, debounceTime, distinctUntilChanged, filter, map, of, switchMap, tap } from "rxjs";
import { PublicApiService } from "../../services/public-api.service";
import { PublicSearchSenderIdItem } from "../../interfaces/public-search-sender-id-item.interface";
import { ExactMatchDirective } from "../../directives/exact-match.directive";
import { RouterModule } from "@angular/router";
import { TableConstants } from "../../constants/table.constant";
import { SpinnerModule } from "common";

@Component({
  selector: 'si-public-sender-id-search',
  templateUrl: './public-sender-id-search.component.html',
  styleUrls: ['./public-sender-id-search.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatLabel,
    MatFormField,
    MatInput,
    MatError,
    MatButton,
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    ExactMatchDirective,
    RouterModule,
    SpinnerModule,
  ],
})
export class PublicSenderIdSearchComponent implements OnInit {
  @ViewChild('senderIdSort', { static: false }) set matSenderIdSort(sort: MatSort) {
    this.senderIdSort = sort;
    if (this.senderIdDataSource) {
      this.senderIdDataSource.sort = this.senderIdSort;
    }
  }
  @ViewChild('senderIdPaginator', { static: false }) set matSenderIdPaginator(paginator: MatPaginator) {
    this.senderIdPaginator = paginator;

    if (this.senderIdDataSource) {
      this.senderIdDataSource.paginator = this.senderIdPaginator;
    }
  };

  private readonly fb = inject(FormBuilder);
  private readonly publicApiService = inject(PublicApiService);

  private senderIdSort: MatSort;
  private senderIdPaginator: MatPaginator;
  public senderIdDataSource = new MatTableDataSource<PublicSearchSenderIdItem>();

  public isFetching = false;
  public isFetched = false;
  public form: FormGroup;

  public columns = ['senderIdText', 'organisationName', 'statusDesc'];

  public TableConstants = TableConstants;

  public ngOnInit(): void {
    this.form = this.fb.group({
      search: new FormControl('', [Validators.maxLength(11), Validators.required, Validators.minLength(3)]),
    })

    this.addSubscriptions();
  }

  private addSubscriptions() {
    this.form.get('search').valueChanges.pipe(
      debounceTime(600),
      distinctUntilChanged(),
      filter((value) => value && this.form.get('search').valid),
      tap(() => this.isFetching = true),
      switchMap((value) =>
        this.publicApiService.getSenderIdsSearch$(value).pipe(
          map((results) => {
            return [...results.filter(r => r.isExactMatch), ...results.filter(r => !r.isExactMatch)];
          }),
          catchError(() => of([]))
        )
      )
    ).subscribe((value) => {
      this.isFetching = false;
      this.isFetched = true;
      this.senderIdDataSource.data = value;
      this.senderIdDataSource.paginator?.firstPage();
    });
  }
}
